import { Stack, useLocalSearchParams } from 'expo-router';

import StoreInfoModalContainer from '@fhs-legacy/frontend/src/components/store-info-modal';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

import { useForwardToStoreLocator } from '../../../../utils/use-forward-to-store-locator';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

/**
 * The v2 locator shows store details in its own panel, so this page only exists to forward
 * guests arriving on the old URL — bookmarks, deep links, anything still pointing here.
 *
 * `/store-locator/store/[idOrNumber]/[slug]` is deliberately left alone: those are the
 * address-based URLs in the sitemap, and they still need to render their own SEO metadata.
 */
export default function StoreDetailsPage() {
  const enableStoreLocatorV2 = useFlag('enable-store-locator-v2');
  const { idOrNumber, ...passthrough } = useLocalSearchParams<{ idOrNumber?: string }>();

  useForwardToStoreLocator({ ...passthrough, storeId: idOrNumber }, Boolean(enableStoreLocatorV2));

  if (enableStoreLocatorV2) {
    // Nothing to show while forwarding, and the modal header would flash over the locator.
    return <Stack.Screen options={{ headerShown: false, animation: 'none' }} />;
  }

  return <StoreInfoModalContainer />;
}
